<template lang="pug">
div
  el-row.padding-bottom(:gutter="30")
    el-col(:span="24")
      app-divider(label="Área a ser permutada")
    el-col(:span="12", v-if="inputsExtraCadastro.imovel.numeroTitulo")
        el-col.inputDiv(:span="24", style="padding: 0;")
          validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/N° do título")
            app-label(label="N° do título:")
            el-input.input(
              name="N° do título",
              v-mask="'##################################################'",
              v-model="imovel.numeroTitulo",
              :class="{'erro' : errors.length}"
            )
            span.help.erro {{ errors[0] }}

    el-col.inputDiv(:span="12", v-if="inputsExtraCadastro.imovel.nomeImovelPropriedade")
        el-col(:span="24", style="padding: 0;")
          validation-provider(rules="required", v-slot="{ errors }", name="Nome do imóvel/Propriedade")
            app-label(label="Nome do imóvel/Propriedade:")
            el-input.input(
              name="Nome do imóvel/Propriedade",
              v-model="imovel.nomeImovelPropriedade",
              :class="{'erro' : errors.length}"
            )
            span.help.erro {{ errors[0] }}

  el-row.padding-bottom(:gutter="30")
    el-col(:span="24")
      app-label(label="Causas da impossibilidade de ocupação:")
      el-col(:span="24", style="padding: 0;")
        validation-provider(rules="required", v-slot="{ errors }", name="Imóvel/Causas da impossibilidade de ocupação")
          el-input.input(
            type="textarea",
            :rows="5",
            v-model="imovel.causasImpossibilidadeOcupacao",
            name="Causas da impossibilidade de ocupação",
            :class="{'erro' : errors.length}"
          )
          span.help.erro {{ errors[0] }}
</template>

<script>
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'
const {inputsExtraCadastro} = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {

  components: {
    AppLabel,
    AppDivider
  },

  data () {
    return {
      inputsExtraCadastro
    }
  },

  props: {
    imovel: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.format {
  text-align: left;
}
.el-row {
  margin-bottom: 20px;
}

@media (max-width: 780px) {
  .inputDiv {
    width: 260px;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/components/cadastro/AppImovelAreaPermutada.vue